@if (documentationAdded()) {
  <div class="ga-documentation-note body-bold" role="status" aria-live="polite">
    <i nz-icon nzType="icons:done" class="svg-icon" aria-hidden="true"></i>
    <span>Documentation successfully added</span>
  </div>
}

@if (notification()) {
  <div
    class="card"
    [class.desktop]="isDesktop()"
    role="region"
    aria-labelledby="notificationTitle"
  >
    <div class="info-area">
      <div class="plant-header">
        @switch (true) {
          @case (notification().isCritical && !notification().inactive) {
            <span class="body-bold-cap red-text">{{
              i18n.langString("problem_detected")
            }}</span>
          }
          @case (notification().inactive) {
            <span class="body-bold-cap grey-text">{{
              i18n.langString("problem_detected")
            }}</span>
          }
          @case (notification().isWarning) {
            <span class="body-bold-cap orange-text">{{
              i18n.langString("warning")
            }}</span>
          }
          @case (
            notification().equipmentType === "Rotating Equipment" &&
            !notification().isCritical &&
            !notification().isWarning &&
            !notification().inactive
          ) {
            <span class="body-bold-cap green-text">
              {{ i18n.langString("working_fine") }}
            </span>
          }
        }
        <span
          class="timestamp"
          [class.body-bold]="isDesktop()"
          [class.detail-bold]="!isDesktop()"
        >
          {{ notification().timestamp | date: dateFormatString() }}
        </span>
      </div>
      <app-breadcrumbs
        [array]="notification().breadcrumbs"
        class="detail breadcrumbsSmallMargin"
      ></app-breadcrumbs>
      <!-- Revisit by Prince, once final Input for breadcrumb is ready -->
      <div
        class="asset_name"
        (click)="onAssetName()"
        (keyup.enter)="onAssetName()"
        role="button"
        tabindex="0"
      >
        <h2 id="notificationTitle">{{ notification().objectName }}</h2>
      </div>
      <span class="body-bold">{{ notification().sensorName }}</span>
      @if (
        notification().isCritical ||
        notification().isWarning ||
        notification().inactive ||
        (notification().equipmentType === "Rotating Equipment" &&
          !notification().isCritical &&
          !notification().isWarning &&
          !notification().inactive)
      ) {
        <app-notification-alert
          [notification]="notification()"
          [dateFormat]="dateFormat()"
        ></app-notification-alert>
      }
    </div>
    @if (notification().isCritical || notification().isWarning) {
      <div class="button-area">
        <div class="button-wrapper no-margin"></div>
        <div class="button-wrapper">
          @if (
            notification().equipmentType !== "Rotating Equipment" &&
            !notification().inactive &&
            !notification().isCritical &&
            !notification().isWarning
          ) {
            <app-nav-button
              [darksecondary]="true"
              svgIcon="icons:instruction"
              (clickEvent)="onRepairAndReplace()"
              (keyup.enter)="onRepairAndReplace()"
              tabindex="0"
            >
              {{ i18n.langString("repair_and_replace") }}
            </app-nav-button>
          }
        </div>
        <div class="button-wrapper">
          @if (notification().equipmentType !== "Rotating Equipment") {
            <app-nav-button
              [darksecondary]="true"
              svgIcon="icons:documentation"
              [disabled]="false"
              (clickEvent)="overlayDocumentation.set(true)"
              (keyup.enter)="overlayDocumentation.set(true)"
              [tabindex]="0"
            >
              {{ i18n.langString("add_documentation") }}
            </app-nav-button>
          }
        </div>
      </div>
    }
    @if (overlayDocumentation()) {
      <app-docu-wizard
        [assetId]="notification().objectID"
        [sensorId]="notification().sensorID"
        (saved)="onDocumentationAdded($event)"
        (closeEvent)="overlayDocumentation.set(false)"
      ></app-docu-wizard>
    }
    @if (overlayInstructions()) {
      <app-sensor-instruction
        (close)="overlayInstructions.set(false)"
        (keyup.enter)="overlayInstructions.set(false)"
        tabindex="0"
      ></app-sensor-instruction>
    }
  </div>
}
